export function downloadFile({
  url,
  filename,
}: {
  url: string
  filename?: string
}) {
  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = url

  if (filename) {
    a.download = filename
  }

  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
